import styled, { keyframes } from 'styled-components';
import theme from './theme';

const overlayIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const dialogIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const ModalOverlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  inset: 0;
  background: ${theme.colors.overlay};
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: ${props => (props.$isOpen ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 99999;
  padding: 20px;
  animation: ${overlayIn} 0.2s ease;
`;

export const ModalDialog = styled.div`
  background: ${theme.colors.card};
  padding: 32px 28px;
  border-radius: ${theme.radius.xl};
  box-shadow: ${theme.shadows.modal};
  border: 1px solid ${theme.colors.cardBorder};
  width: 100%;
  max-width: 420px;
  position: relative;
  z-index: 100000;
  animation: ${dialogIn} 0.3s cubic-bezier(0.34, 1.2, 0.64, 1);

  @media (max-width: 480px) {
    padding: 24px 20px;
    border-radius: ${theme.radius.lg};
  }
`;

export const ModalTitle = styled.h3`
  color: ${theme.colors.text};
  margin-bottom: 12px;
  font-size: ${theme.typography.h2};
  font-weight: 700;
  text-align: center;
  letter-spacing: -0.03em;
`;

export const ModalMessage = styled.p`
  color: ${theme.colors.textMuted};
  margin-bottom: 8px;
  font-size: ${theme.typography.body};
  text-align: center;
  line-height: 1.6;
`;

export const ModalButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 28px;
  flex-wrap: wrap;
`;

export const ModalButton = styled.button<{ $primary?: boolean }>`
  padding: 12px 24px;
  border-radius: ${theme.radius.pill};
  font-size: ${theme.typography.body};
  font-weight: 600;
  cursor: pointer;
  transition: all ${theme.transitions.base};
  min-width: 120px;
  letter-spacing: -0.01em;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
  }

  ${props =>
    props.$primary
      ? `
    background: ${theme.colors.accentGradient};
    color: white;
    border: none;
    box-shadow: ${theme.shadows.glowSoft};

    &:hover:not(:disabled) {
      box-shadow: ${theme.shadows.glow};
      transform: translateY(-1px);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }
  `
      : `
    background: ${theme.colors.card};
    color: ${theme.colors.textSecondary};
    border: 1px solid ${theme.colors.cardBorder};

    &:hover:not(:disabled) {
      background: ${theme.colors.bg};
      border-color: ${theme.colors.border};
      color: ${theme.colors.text};
    }
  `}
`;
